/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `stripe` - Stripe
 * * `free` - Free
 * * `manual` - Manual
 * @export
 */
export const BillingModeEnum = {
    Stripe: 'stripe',
    Free: 'free',
    Manual: 'manual'
} as const;
export type BillingModeEnum = typeof BillingModeEnum[keyof typeof BillingModeEnum];


export function instanceOfBillingModeEnum(value: any): boolean {
    for (const key in BillingModeEnum) {
        if (Object.prototype.hasOwnProperty.call(BillingModeEnum, key)) {
            if (BillingModeEnum[key as keyof typeof BillingModeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BillingModeEnumFromJSON(json: any): BillingModeEnum {
    return BillingModeEnumFromJSONTyped(json, false);
}

export function BillingModeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingModeEnum {
    return json as BillingModeEnum;
}

export function BillingModeEnumToJSON(value?: BillingModeEnum | null): any {
    return value as any;
}

export function BillingModeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): BillingModeEnum {
    return value as BillingModeEnum;
}
